// extracted by mini-css-extract-plugin
module.exports = {"Checking":"version_Checking__1FaSU","UpdateButton":"version_UpdateButton__1JX8q","Container":"version_Container__3ybI6"};